import { createApiHooks, useGenericGet, useGenericPost } from '../../../../../hooks/use-api.hook';
import { apiClient } from '../../../../../services/api-client.service';
import type {
  Country,
  CountryCreate,
  CountryGetFiltersResponse,
  CountryGetResponse,
  CountryUpdate,
} from '../types/country.types';
import type { UseListParams } from '../../../../../types/pagination.types';

const countryBasePath = '/v1/sysadmin/Countries';

export const countryHooks = createApiHooks<
  Country,
  CountryGetResponse,
  CountryCreate,
  CountryUpdate
>({
  basePath: countryBasePath,
  queryKey: ['Countries'],
  apiClient,
});

export const useCountryGetFilters = (queryOptions?: any) => {
  return useGenericGet<CountryGetFiltersResponse>(
    `${countryBasePath}/filters`,
    ['Countries', 'filters'],
    apiClient,
    queryOptions
  );
};

export const {
  useGet: useCountryGet,
  useCreate: useCountryCreate,
  useUpdate: useCountryUpdate,
  useDelete: useCountryDelete,
} = countryHooks;

// Using custom implementation for list to better handle filter params
export const useCountryList = (params: UseListParams) => {
  return countryHooks.useList(params);
};
